import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Icon } from 'components/icon'
import { MemorySelectOption } from 'components/memory/MemoryUtils'
import NextImage from 'next/legacy/image'
import { colors } from 'utils/colors'
import { pxToRem } from 'utils/styled'
import { ImageWithFallback } from 'components/content/memory/imageWithFallback/ImageWithFallback'

export const SMemoryItem = styled.div<{
  selected?: boolean
}>`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background-color: var(--c-blue100);
  transition: padding 0.5s, border 0.5s;
  border: 0 solid var(--c-blue100);
  ${({ selected }) =>
    selected &&
    css`
      border-width: 16px;
    `}
`

export const STopInnerShadow = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  padding: 0.5rem;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  top: 0;
  left: 0;
  right: 0;
`

export const SPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--c-gray300);
  border: 2px solid var(--c-blue100);
  width: 100%;
  height: 100%;
  & > span {
    color: var(--c-blue500);
  }
`

export const SImage = styled(NextImage, {
  shouldForwardProp: (prop) => prop !== 'selectionMode',
})<{ selectionMode?: MemorySelectOption }>`
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: transform 0.5s;
  ${({ selectionMode }) => {
    if (selectionMode === 'none') {
      return css`
        &:hover {
          transform: scale(1.2);
        }
      `
    } else return null
  }}
`

export const SVideoWrapper = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
`

export const SSelectedIcon = styled(Icon)`
  position: absolute;
  color: ${colors.blue[500]};
  z-index: 2;
  top: ${pxToRem(8)}rem;
  left: ${pxToRem(8)}rem;
`

export const SThumbnailImage = styled(ImageWithFallback)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const playerContainerCss = css`
  height: 100%;
  width: 100%;
`

export const playerCss = css`
  object-fit: cover;
`
